import { ACL, ROLES } from "models";

export type UserID = number;

export enum USER_STATUSES {
  First = 1,
  Active = 1,
  Inactive = 2,
  Last = 2
}

export interface User {
  created_on: string;
  updated_on: string;
  id: UserID; // Recalls User ID
  role: ROLES; // User Role
  session_expire_at: string; // Session expire time
  email: string; // Email address
  status: USER_STATUSES; // User status
  acl?: ACL[]; // ACLs of the user
}
